import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../lib/withRouter';
import './ContactUs.scss';

class ContactUs extends Component {
    goBack = () => {
        this.props.navigate('/login');
    };

    getFullAddress = () => {
        const { address, city, state, country, pincode } = this.props;
        const parts = [address, city, state, country].filter(Boolean);
        let full = parts.join(', ');
        if (pincode) full += ` - ${pincode}`;
        return full;
    };

    getMapUrl = () => {
        const { latitude, longitude } = this.props;
        if (!latitude || !longitude) return null;
        return `https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${latitude},${longitude}&zoom=15`;
    };

    render() {
        const {
            orgTitle, orgName, yearOfESTD,
            mobileOperational, mobileAccounts,
            emailOperational, emailAccounts,
            logoRectangle, latitude, longitude
        } = this.props;

        const fullAddress = this.getFullAddress();
        const mapUrl = this.getMapUrl();
        const googleMapsLink = (latitude && longitude)
            ? `https://www.google.com/maps?q=${latitude},${longitude}`
            : null;

        return (
            <div className="cu-page">
                <div className="cu-header">
                    <button className="cu-back-btn" onClick={this.goBack}>
                        <i className="pi pi-arrow-left" />
                    </button>
                    <span className="cu-header-title">Contact Us</span>
                </div>

                <div className="cu-content">
                    <div className="cu-hero">
                        <div className="cu-hero-inner">
                            {logoRectangle?.storageLocation && (
                                <div className="cu-logo-wrap">
                                    <img
                                        className="cu-logo"
                                        src={logoRectangle.storageLocation}
                                        alt={orgTitle || 'Logo'}
                                    />
                                </div>
                            )}
                            <div className="cu-hero-text">
                                {orgTitle && <h1 className="cu-org-name">{orgTitle}</h1>}
                                {orgName && orgName !== orgTitle && (
                                    <p className="cu-org-sub">{orgName}</p>
                                )}
                                {yearOfESTD && (
                                    <span className="cu-estd">Est. {yearOfESTD}</span>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="cu-main">
                        <div className="cu-cards">
                            {fullAddress && (
                                <div className="cu-card">
                                    <div className="cu-card-icon cu-card-icon--location">
                                        <i className="pi pi-map-marker" />
                                    </div>
                                    <div className="cu-card-body">
                                        <span className="cu-card-label">Address</span>
                                        <span className="cu-card-value">{fullAddress}</span>
                                    </div>
                                </div>
                            )}
                            {(mobileOperational || mobileAccounts) && (
                                <div className="cu-card">
                                    <div className="cu-card-icon cu-card-icon--phone">
                                        <i className="pi pi-phone" />
                                    </div>
                                    <div className="cu-card-body">
                                        <span className="cu-card-label">Phone</span>
                                        <div className="cu-card-links">
                                            {mobileOperational && (
                                                <a href={`tel:${mobileOperational}`} className="cu-card-link">
                                                    {mobileOperational}
                                                </a>
                                            )}
                                            {mobileAccounts && mobileAccounts !== mobileOperational && (
                                                <a href={`tel:${mobileAccounts}`} className="cu-card-link">
                                                    {mobileAccounts}
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {(emailOperational || emailAccounts) && (
                                <div className="cu-card">
                                    <div className="cu-card-icon cu-card-icon--email">
                                        <i className="pi pi-envelope" />
                                    </div>
                                    <div className="cu-card-body">
                                        <span className="cu-card-label">Email</span>
                                        <div className="cu-card-links">
                                            {emailOperational && (
                                                <a href={`mailto:${emailOperational}`} className="cu-card-link">
                                                    {emailOperational}
                                                </a>
                                            )}
                                            {emailAccounts && emailAccounts !== emailOperational && (
                                                <a href={`mailto:${emailAccounts}`} className="cu-card-link">
                                                    {emailAccounts}
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="cu-map-section">
                            {mapUrl ? (
                                <div className="cu-map-card">
                                    <iframe
                                        title="Organization Location"
                                        src={mapUrl}
                                        width="100%"
                                        height="100%"
                                        style={{ border: 0, display: 'block', minHeight: '360px' }}
                                        allowFullScreen
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                    />
                                    {googleMapsLink && (
                                        <a
                                            href={googleMapsLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="cu-directions"
                                        >
                                            <i className="pi pi-directions" />
                                            Get Directions
                                        </a>
                                    )}
                                </div>
                            ) : (
                                <div className="cu-no-map">
                                    <i className="pi pi-map" />
                                    <span>Location not available</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    orgTitle: state.orgData.title,
    orgName: state.orgData.name,
    address: state.orgData.address,
    city: state.orgData.city,
    state: state.orgData.state,
    country: state.orgData.country,
    pincode: state.orgData.pincode,
    mobileOperational: state.orgData.mobileOperational,
    mobileAccounts: state.orgData.mobileAccounts,
    emailOperational: state.orgData.emailOperational,
    emailAccounts: state.orgData.emailAccounts,
    yearOfESTD: state.orgData.yearOfESTD,
    latitude: state.orgData.latitude,
    longitude: state.orgData.longitude,
    logoRectangle: state.orgData.logoRectangle,
});

export default connect(mapStateToProps)(withRouter(ContactUs));
